import { createFileRoute } from '@tanstack/react-router'
import { type } from 'arktype'

import { EndorsementExclusionPage } from '../../../../../../../components/pages/endorsement/exclusion-page.tsx'

const exclusionSearchSchema = type({
  'description?': 'string | undefined',
})

export const Route = createFileRoute('/(customer)/contracts/$subscriptionId/endorsements/$endorsementId/exclusion')({
  validateSearch: exclusionSearchSchema,
  component: function Component() {
    const { subscriptionId } = Route.useParams()
    const { description } = Route.useSearch()

    return <EndorsementExclusionPage subscriptionId={subscriptionId} description={description} />
  },
})
